import { render } from "./ForumPostItem.vue?vue&type=template&id=d1527606&scoped=true"
import script from "./ForumPostItem.vue?vue&type=script&lang=js"
export * from "./ForumPostItem.vue?vue&type=script&lang=js"

import "./ForumPostItem.vue?vue&type=style&index=0&id=d1527606&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1527606"]])

export default __exports__